export default __webpack_public_path__ + "static/media/boy_s.37d2ba59.png";